import { Field } from '@fluentui/react-components';
import { IFieldDefinition } from 'src/tenantConfig/interface/FieldDefinition';
import { IFieldDefinitionDTO } from 'src/tenantConfig/interface/FieldDefinitionDTO';

export const MapIFieldDefinitionDTOToIFieldDefinition = (
  FieldDefinitionDTO: IFieldDefinitionDTO[]
): IFieldDefinition[] => {
  if (!FieldDefinitionDTO || FieldDefinitionDTO?.length === 0) {
    return [];
  }

  const fieldDefinitions: IFieldDefinition[] | undefined = FieldDefinitionDTO?.map((field) => ({
    fieldId: field?.FieldId,
    fieldName: field?.FieldName,
    fieldType: field?.FieldType,
    internalName: field?.InternalName,
    responseFormat: field?.ResponseFormat,
    fieldDropdownName: field?.FieldDropdownName,
    keyName: field?.KeyName,
    fieldDropdownDisplayNameKey: field?.FieldDropdownDisplayNameKey,
    isDefault: field?.IsDefault,
    isFilterable: field?.IsFilterable,
    isColumnOption: field?.IsColumnOption,
    useQuery: field?.UseQuery,
  }));

  return fieldDefinitions || [];
};
